module.exports = __webpack_public_path__ + "static/media/heroimage_igib-015.32fb831e.jpg";